/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Pay_LeadInputs */

const en_features_pay_lead = /** @type {(inputs: Features_Pay_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payments without reminders.`)
};

const pl_features_pay_lead = /** @type {(inputs: Features_Pay_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Płatności bez przypominania.`)
};

/**
* | output |
* | --- |
* | "Payments without reminders." |
*
* @param {Features_Pay_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_pay_lead = /** @type {((inputs?: Features_Pay_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Pay_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_pay_lead(inputs)
	return en_features_pay_lead(inputs)
});